module.exports = __webpack_public_path__ + "img/caja.9df051a2.png";